import { useState, useEffect } from 'react';

export function animateFloatingText(text, color, size) 
  {
// Create floating text element
const floatingText = document.createElement('div');
floatingText.textContent = text;
floatingText.style.cssText = `
  position: fixed;
  color:${color};
  font-size: ${size};
  pointer-events: none;
  animation: floatAndFade 2s ease-out forwards;
  z-index: 1000;
`;

// Get click coordinates from the event
const event = window.event;
if (event) {
  floatingText.style.left = `${event.clientX -40}px`;
  floatingText.style.top = `${event.clientY - 20}px`;
}

// Add the element to the body
document.body.appendChild(floatingText);

// Remove the element after animation
setTimeout(() => {
  document.body.removeChild(floatingText);
}, 1000);
  }

export function copyToClipboard(stringToCopy) {
    // Copy to clipboard
    navigator.clipboard.writeText(stringToCopy);
    
    animateFloatingText("Copied to Clipboard", "#82ad78", "20px");
  }
  
export function isMobile()
{
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

export function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
}